export var ACTIONS = /*#__PURE__*/function (ACTIONS) {
  ACTIONS[ACTIONS["UPDATE_PLUGIN_STATE"] = 0] = "UPDATE_PLUGIN_STATE";
  ACTIONS[ACTIONS["TOGGLE_SPELLING_AND_GRAMMAR_ENABLED"] = 1] = "TOGGLE_SPELLING_AND_GRAMMAR_ENABLED";
  ACTIONS[ACTIONS["DISABLE_NEED_SPELLING_AND_GRAMMAR"] = 2] = "DISABLE_NEED_SPELLING_AND_GRAMMAR";
  ACTIONS[ACTIONS["UPDATE_CHUNK_METADATA"] = 3] = "UPDATE_CHUNK_METADATA";
  ACTIONS[ACTIONS["START_SPELLING_AND_GRAMMAR"] = 4] = "START_SPELLING_AND_GRAMMAR";
  return ACTIONS;
}({});